<h1 mat-dialog-title>Mensagem</h1>
<div mat-dialog-content>
  {{data}}
</div>
<mat-dialog-actions>
  <button [mat-dialog-close]="true" mat-button>OK</button>
</mat-dialog-actions>
